import Badge from './Badge';

export default {
  id: 'radial_12',
  title: 'Radial_12',
  colors: 3,
  animated: true,
  premium: true,
  BadgeComponentStateless: Badge
};
